import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
interface NavLink {
  name: string;
  href: string;
  isExternal?: boolean;
  adminOnly?: boolean;
}
interface NavLinksProps {
  links: NavLink[];
  variant?: "desktop" | "mobile";
  onNavigate?: () => void;
}
export function NavLinks({
  links,
  variant = "desktop",
  onNavigate
}: NavLinksProps) {
  const navigate = useNavigate();
  const handleNavigation = (path: string) => {
    navigate(path);
    if (onNavigate) onNavigate();
  };
  return <>
      {links.map(link => <Button key={link.name} variant="ghost" onClick={() => handleNavigation(link.href)} className="font-bold mx-[6px] my-0text-left text-base text-slate-50 bg-krecao-red rounded-xl">
          {link.name}
        </Button>)}
    </>;
}